import { render } from "./XmlMapperPositionList.vue?vue&type=template&id=38ecee5c&scoped=true&ts=true"
import script from "./XmlMapperPositionList.vue?vue&type=script&lang=ts"
export * from "./XmlMapperPositionList.vue?vue&type=script&lang=ts"

import "./XmlMapperPositionList.vue?vue&type=style&index=0&id=38ecee5c&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38ecee5c"]])

export default __exports__